import configService from './configService';

export default configService;
